module.exports = __webpack_public_path__ + "static/img/9.d247461.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/9.png
// module id = n2xd
// module chunks = 1